import { Button } from '@mui/material'
import React from 'react'
import Copyright from '../../components/ModalComponents/Copyright'
import { useParams } from 'react-router-dom';


const Thankyou = () => {
	const { id } = useParams();
	const handelThankyou = () => {
		window.location.replace(`/testX27QF0rPxLljNoAq71sgROuRuJd0A40aApO_EALw_wcB=preview/${id}`)
	}
	return (
		<div className="thankyoucontent">
			<div className="wrapper-1">
				<div className="wrapper-2">
					<img src="https://i.ibb.co/Lkn7rkG/thank-you-envelope.png" alt="thank-you-envelope" />
					<h1>Thank you!</h1>
					<p>Thank you for applying, we will be in touch shortly.</p>
					<p>We appreciate your interest in the program, and we look forward to reviewing your application!</p>
					<p>once your message is received. </p>
					<Button className="go-home" onClick={handelThankyou}>
						home page
					</Button>
				</div>
				<div className="footer-like">
					<p>
						<Copyright />
					</p>
				</div>
			</div>
		</div>

	)
}

export default Thankyou
